export default __webpack_public_path__ + "images/f8c65ec8e3afc87fb2e4a5e963ed1b6c.png";